import { clearApplicationDraft } from '../../utils/applicationDraft';
import { clearQuickCashDraft } from './storage';

// Quick Cash OTP가 성공한 시점에만 기존 일반 신청을 종료한다.
// 일반 신청 화면에서는 이 모듈을 import하지 않으므로 상품 간 의존 방향은
// Quick Cash -> 일반 신청 데이터 정리의 단방향으로 유지된다.
export const clearPreviousApplicationForQuickCash = () => {
  clearApplicationDraft();
  localStorage.removeItem('access_token');
  localStorage.removeItem('application_phone');
  localStorage.removeItem('expired_date');
};

// Quick Cash 완료 후에는 이 상품의 draft와 공용 인증값만 정리한다.
export const clearCompletedQuickCashApplication = () => {
  clearQuickCashDraft();
  localStorage.removeItem('access_token');
  localStorage.removeItem('application_phone');
  localStorage.removeItem('expired_date');
};
